import { render, staticRenderFns } from "./CadastroVeiculo.vue?vue&type=template&id=2d9d460e"
import script from "./CadastroVeiculo.vue?vue&type=script&lang=js"
export * from "./CadastroVeiculo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports